export const revalidateTimes = {
  fiveMin: 300,
  fiveMinInMs: 300000,
};
